import {useState} from "react";
import NiceModal from "@ebay/nice-modal-react";
import {CustomDialog, FormControl, InputLabel, Text} from "@bounce/shared/ui";
import {MenuItem, Select} from "../../ui/components";
import {CONTENT_CHANNEL_LABELS, CONTENT_CHANNELS, UNSUPPORTED_CHANNELS} from "./templateFormSchema";
import {ReachTemplateContentChannel} from "../../apis/requests/templates/types";

type Props = {
  defaultChannel: ReachTemplateContentChannel;
  hasPendingChanges?: boolean;
  onConfirm: (channel: ReachTemplateContentChannel) => void;
};

const DuplicateTemplateDialog = NiceModal.create(({defaultChannel, hasPendingChanges, onConfirm}: Props) => {
  const [channel, setChannel] = useState<ReachTemplateContentChannel>(defaultChannel);

  return (
    <CustomDialog
      title="Duplicate template"
      forceTitle
      buttonText={hasPendingChanges ? "Save & Duplicate" : "Duplicate"}
      onClick={() => onConfirm(channel)}
    >
      <Text size={14}>
        {hasPendingChanges
          ? "You have unsaved changes. They will be saved before duplicating."
          : "Select the content channel for the duplicated template. You'll be able to review the copy before saving it."}
      </Text>
      <FormControl fullWidth size="small">
        <InputLabel>Content channel *</InputLabel>
        <Select
          value={channel}
          onChange={(e) => setChannel(e.target.value as ReachTemplateContentChannel)}
          label="Content channel *"
        >
          {CONTENT_CHANNELS.map((c) => (
            <MenuItem key={c} value={c} disabled={UNSUPPORTED_CHANNELS.has(c)}>
              {CONTENT_CHANNEL_LABELS[c]}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </CustomDialog>
  );
});

export default DuplicateTemplateDialog;
